import AuthComposer from './AuthComposer';
import PasswordComposer from './PasswordComposer';
import EmailComposer from './EmailComposer';

export default AuthComposer;
export { PasswordComposer, EmailComposer };
